import { useState } from 'react';
import UI from '../ui';
import { present } from '../helpers/present';

const features = [
  'Staff',
  'Design',
  'Pool',
  'Location',
  'Family Friendly',
  'Cleanliness',
  'Food',
  'Facilities',
  'Amenities',
  'Entertainment',
  'Ambiance',
  'Security',
];

const travelCompanions = [
  'Solo',
  'Couple',
  'Family',
  'Friends',
];

const travelStyles = [
  'Luxury',
  'Budget-conscious',
  'Adventure',
  'Cultural Explorer',
  'Foodie',
  'Relaxation-seeker',
  'Nightlife Lover',
  'Shopping enthusiast',
  'Business',
];

// const travelPurpose = [
//   'Business',
//   'Leisure',
//   'Both',
// ];

export const travelOptions = { features, travelCompanions, travelStyles };

// TODO: generic option types?
// TODO: outside of the prototype, the state would by managed by the parent
export const Options: React.FC<{ title: string, subtitle?: string, options: string[], max?: number, onSelect?: (options: string[]) => void }>
= ({ title, subtitle, options, max, onSelect }) => {
  const maxSelections = present(max) ? max : options.length;
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const select: (options: string[]) => void = (options) => {
    setSelectedOptions(options);
    if (onSelect) {
      onSelect(options);
    };
  };
  return (
    <UI.VerticalLayout>
      <UI.Text weight="bold" size="title">{title}</UI.Text>
      {subtitle && <UI.Text>{subtitle}</UI.Text>}
      <UI.HorizontalLayout gap={5} wrap="wrap">
        {options.map((option, i) => {
          const selected = selectedOptions.includes(option);
          return (
            <UI.Button
              key={i}
              label={option}
              type={selected ? 'tertiary' : 'secondary'}
              onClick={
                () => {
                  if (selected) {
                    const value = selectedOptions.filter(x => x !== option);
                    select(value);
                  }
                  else if (selectedOptions.length < maxSelections) {
                    const value = [...selectedOptions, option];
                    select(value);
                  }
                  else if (maxSelections === 1) { // If user can only select one, replace old choice with new one
                    const value = [option];
                    select(value);
                  }
                }
              }
            />
          );
        })}
      </UI.HorizontalLayout>
    </UI.VerticalLayout>
  );
};
